import { map, Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

import { ModalService } from '@shared/components/modal-list/modal-list.service';
import { ButtonComponent } from '@shared/components/button/button.component';

import { CartService } from '@b2b/features/cart/core/cart.service';

import { CartTotalsComponent } from '@b2b/components/cart/cart-totals/cart-totals.component';
import { CartFurnisherComponent } from '@b2b/components/cart/cart-furnisher/cart-furnisher.component';
import { CartCouponComponent } from '@b2b/components/cart/cart-coupon/cart-coupon.component';
import { CartSaveModalComponent } from '@b2b/components/cart/cart-main/components/cart-save-modal/cart-save-modal.component';
import { TranslateModule } from '@ngx-translate/core';
import { LocalLoaderComponent } from '@shared/components/loader/local-loader/local-loader.component';

@Component({
  selector: 'cart-main',
  imports: [
    CommonModule,
    RouterModule,
    ButtonComponent,
    CartTotalsComponent,
    CartFurnisherComponent,
    CartCouponComponent,
    TranslateModule,
    LocalLoaderComponent,
  ],
  templateUrl: './cart-main.component.html',
  styleUrl: './cart-main.component.scss',
})
export class CartMainComponent implements OnInit, OnDestroy {
  subscription = new Subscription();

  cart$ = this.cartService.getCart();

  templateContext$ = this.cart$.pipe(
    map(cart => ({
      cart,
      isEmpty: (cart.data?.entries?.length ?? 0) === 0,
    })),
  );

  constructor(
    private cartService: CartService,
    private modalService: ModalService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.cartService.fetchCart(this.cartService.getCartID());
    this.scrollToSection('cart-container');
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  scrollToSection(sectionId: string) {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  onSaveCart() {
    this.modalService.addModal({
      disableClose: false,
      hasCloseButton: true,
      id: 'save-cart-modal',
      title: '',
      width: 430,
      component: CartSaveModalComponent,
    });
  }

  goToCartList() {
    this.router.navigate(['/carrinho/listagem']);
  }

  goToCartImport() {
    this.router.navigate(['/carrinho/import']);
  }

  goToCartReview() {
    this.router.navigate(['/checkout/modo-entrega']);
  }
}
